import { render, staticRenderFns } from "./ImsProfitLossBuys.vue?vue&type=template&id=a954766e&"
import script from "./ImsProfitLossBuys.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossBuys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports